// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body > div {
 height: 95vh;
}
.input-rounded{
  border: 2px solid #00aaaf;
  border-radius: 5px;
  margin-top: 5px;
  padding: 5px;
  width: 97%;
  margin-right: 5px;
  color: #00aaaf;
  background-color: #fff;
}
.input-rounded2{
  border: 2px solid #00aaaf;
  width: 97%;
  border-radius: 5px;
  margin-top: 5px;
  padding: 5px;
  margin-bottom: 5px;
  background-color: #00aaaf !important;
}
.chat-rounded{
  border: 2px solid #00aaaf;
  border-radius: 5px;
  margin-top: 5px;
  padding: 5px;
  margin-right: 5px;
  background-color: #00aaaf;
  height: 45px;
  width: 75px;
}
.chat-div{
  border: 2px solid #00aaaf;
  border-radius: 5px;
  margin-top: 5px;
  margin: 5px;
  padding: 5px;
  height: 85%;
  overflow: auto;
  position: relative;
  width: 100%-10px;
}
.chat-input-div{
  padding: 10px;
  bottom: 0;
}
.forum-item{
  width: "100%";
  border-bottom: 1px solid #e7f4f6;
  display: 'flex';
  justify-content: 'flex-end';
  align-items: 'center';
  overflow: 'auto';
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.username {
    color: #c9c9c9;
    font-size: 12px;
}
 .avatar { width: 36; height: 36; border-radius: 18; margin-right: 10; background-color: '#eee'; float: "left" }
 .avatarPlaceholder { background-color: '#ccc' }
     .DiscussionListItem-count:before {
         -moz-osx-font-smoothing: grayscale;
         -webkit-font-smoothing: antialiased;
         display: inline-block;
         font-style: normal;
         font-variant: normal;
         text-rendering: auto;
         line-height: 1;
         font-family: 'Font Awesome 5 Free';
         font-weight: 400;
         content: "\\f075";
         margin-left: -21px;
         margin-top: 3px;
     }
    .DiscussionListItem-count {
        margin-top: 12px;
        width: 55px;
        color: var(--muted-color);
        font-size: 14px;
        padding-left: 0px;
    }
    .DiscussionListItem-count {

        margin-top: 12px;
        text-decoration: none;
    }`, "",{"version":3,"sources":["webpack://./src/components/Forum.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;IACI,cAAc;IACd,eAAe;AACnB;CACC,UAAU,SAAS,EAAE,UAAU,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,cAAc;CAC9G,qBAAqB,yBAAyB;KAC1C;SACI,kCAAkC;SAClC,mCAAmC;SACnC,qBAAqB;SACrB,kBAAkB;SAClB,oBAAoB;SACpB,oBAAoB;SACpB,cAAc;SACd,kCAAkC;SAClC,gBAAgB;SAChB,gBAAgB;SAChB,kBAAkB;SAClB,eAAe;KACnB;IACD;QACI,gBAAgB;QAChB,WAAW;QACX,yBAAyB;QACzB,eAAe;QACf,iBAAiB;IACrB;IACA;;QAEI,gBAAgB;QAChB,qBAAqB;IACzB","sourcesContent":["body > div {\n height: 95vh;\n}\n.input-rounded{\n  border: 2px solid #00aaaf;\n  border-radius: 5px;\n  margin-top: 5px;\n  padding: 5px;\n  width: 97%;\n  margin-right: 5px;\n  color: #00aaaf;\n  background-color: #fff;\n}\n.input-rounded2{\n  border: 2px solid #00aaaf;\n  width: 97%;\n  border-radius: 5px;\n  margin-top: 5px;\n  padding: 5px;\n  margin-bottom: 5px;\n  background-color: #00aaaf !important;\n}\n.chat-rounded{\n  border: 2px solid #00aaaf;\n  border-radius: 5px;\n  margin-top: 5px;\n  padding: 5px;\n  margin-right: 5px;\n  background-color: #00aaaf;\n  height: 45px;\n  width: 75px;\n}\n.chat-div{\n  border: 2px solid #00aaaf;\n  border-radius: 5px;\n  margin-top: 5px;\n  margin: 5px;\n  padding: 5px;\n  height: 85%;\n  overflow: auto;\n  position: relative;\n  width: 100%-10px;\n}\n.chat-input-div{\n  padding: 10px;\n  bottom: 0;\n}\n.forum-item{\n  width: \"100%\";\n  border-bottom: 1px solid #e7f4f6;\n  display: 'flex';\n  justify-content: 'flex-end';\n  align-items: 'center';\n  overflow: 'auto';\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.username {\n    color: #c9c9c9;\n    font-size: 12px;\n}\n .avatar { width: 36; height: 36; border-radius: 18; margin-right: 10; background-color: '#eee'; float: \"left\" }\n .avatarPlaceholder { background-color: '#ccc' }\n     .DiscussionListItem-count:before {\n         -moz-osx-font-smoothing: grayscale;\n         -webkit-font-smoothing: antialiased;\n         display: inline-block;\n         font-style: normal;\n         font-variant: normal;\n         text-rendering: auto;\n         line-height: 1;\n         font-family: 'Font Awesome 5 Free';\n         font-weight: 400;\n         content: \"\\f075\";\n         margin-left: -21px;\n         margin-top: 3px;\n     }\n    .DiscussionListItem-count {\n        margin-top: 12px;\n        width: 55px;\n        color: var(--muted-color);\n        font-size: 14px;\n        padding-left: 0px;\n    }\n    .DiscussionListItem-count {\n\n        margin-top: 12px;\n        text-decoration: none;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
